import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  title: string;
};

const TitleOptional = ({ title }: Props) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" alignItems="center" gap="4px">
      <Typography variant="header">{title}</Typography>
      <Typography
        variant="header"
        fontWeight="500"
        fontSize="12px"
        color="textSecondary"
        textTransform="capitalize"
      >
        {t("common:optionalDash")}
      </Typography>
    </Box>
  );
};

export default TitleOptional;
